import { render, staticRenderFns } from "./DataMonitor.vue?vue&type=template&id=684306b4&"
import script from "./DataMonitor.vue?vue&type=script&lang=js&"
export * from "./DataMonitor.vue?vue&type=script&lang=js&"
import style0 from "./DataMonitor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports